import {
  MyCleaningsHeader,
  MyCleaningsHistoryList,
} from '@/features/consumer/my-cleanings-bookings';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/(consumer)/_authenticated/bookings/history'
)({
  component: BookingsHistoryPage,
});

function BookingsHistoryPage() {
  return (
    <div>
      <MyCleaningsHeader active="history" />
      <MyCleaningsHistoryList />
    </div>
  );
}
